// Util to handle calculated DSP metrics (i.e. eCPM: `(cost / impressions) * 1000`)
export const extendDSPMetrics = (data) => {
  if (!data) {
    return [];
  }
  const extendedData = data?.map((row) => {
    const { impressions, total_cost } = row ?? {};
    const ecpm = (total_cost / impressions) * 1000;

    return { ...row, ecpm };
  });

  return extendedData;
};
